import { api } from './client'

export type ServicoDeTransporte = 'correios' | 'braspress' | 'printone'

export type SituacaoDoServico = {
  servico: ServicoDeTransporte
  habilitado: boolean
  configurado: boolean

  /** De onde a credencial vem: `portal` (banco, cifrada) ou `arquivo` (recuo). */
  origem: 'portal' | 'arquivo' | null

  /** Identificadores — voltam inteiros de propósito, para dar para conferir o cadastro. */
  campos: Record<string, string>

  /**
   * 🔴 Só os quatro últimos caracteres. O segredo inteiro NUNCA volta pela API:
   * segredo que a API devolve é segredo que vaza no log do navegador, no HAR e
   * no print de tela.
   */
  segredos: Record<string, string>
}

export type ResultadoDoTeste = {
  ok: boolean

  /** Diz o que fazer — falha de rede não é credencial errada (`SEC-11`). */
  mensagem: string
}

export const transporte = {
  listar: () => api.get<SituacaoDoServico[]>('/transporte'),

  gravar: (servico: ServicoDeTransporte, campos: Record<string, string>) =>
    api.put<SituacaoDoServico>(`/transporte/${servico}`, campos),

  testar: (servico: ServicoDeTransporte) =>
    api.post<ResultadoDoTeste>(`/transporte/${servico}/testar`, {}),
}
